import { Routes } from '@angular/router';
import { CustomTodayComponent } from './custom-today/custom-today.component';
import { AuthGuard } from '@app/guards/auth.guard';
import { Constants } from '@app/common/constants';
import { DEFAULT_MODAL_ROUTE_CONFIG } from '@app/common/default-modal-route-config';
import { CustomFindInformationComponent } from './views/custom-find-information/custom-find-information.component';
import { DefaultRoutes } from '@app/common/default-routes';
import { CustomCollaborationComponent } from './views/custom-collaboration/custom-collaboration.component';

export const CAFCASS_CUSTOM_ROUTE_CONFIG: Routes = [
  {
    path: '', component: CustomTodayComponent, pathMatch: 'full', canActivate: [AuthGuard], data: Constants.TODAY_DEFAULT_DATA
  },
  DefaultRoutes.YOUR_BOARD,
  {
    path: 'collaboration', component: CustomCollaborationComponent, canActivate: [AuthGuard], data: Constants.COLLABORATION_DEFAULT_DATA
  },
  {
    path: 'find-information', component: CustomFindInformationComponent, canActivate: [AuthGuard], data: Constants.FIND_INFO_DEFAULT_DATA
  },
  DefaultRoutes.APPS_TOOLS,
  DefaultRoutes.SETTINGS,
  DefaultRoutes.CREATE_SITE,
  DefaultRoutes.EDITOR_DASHBOARD,
  DefaultRoutes.FIRST_DAY,
  DefaultRoutes.ADMIN,
  DefaultRoutes.ABOUT,
  DefaultRoutes.PEOPLE,
  DefaultRoutes.BROADCAST_MESSAGES,
  DefaultRoutes.RESTAURANT,
  DefaultRoutes.PAGES,
  DefaultRoutes.KPI_CHARTS,
  DefaultRoutes.INFOBOXES,
  DefaultRoutes.POWER_BI,
  {
    path: '**', redirectTo: ''
  },
  ...DEFAULT_MODAL_ROUTE_CONFIG
];
